/* global gtag */

import eventEmitter, { PRIVACY_SETTINGS_CONFIRMED } from 'Lib/utils/emitter';
import loadScript from 'Lib/utils/loadScript';

import { KEY_GOOGLE_ANALYTICS, KEY_GOOGLE_FLOODLIGHT } from 'Store/privacy/constants';

const init = ({
  gaPropertyID,
  gCrossMediaFloodlightID,
  googleAdsRemarketingID,
  analytics,
}: {
  gaPropertyID?: string;
  gCrossMediaFloodlightID?: string;
  googleAdsRemarketingID?: string;
  analytics: {
    gtag: string;
  };
}) => {
  if (!__TEST__ && (!__CLIENT__ || (!gaPropertyID && !gCrossMediaFloodlightID))) {
    return;
  }

  // Set up placeholder prior to loading the script
  let isPlaceholder = true;
  // https://developers.google.com/adwords-remarketing-tag/
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
    };

  // Need to wait for signal that the user has confirmed their privacy settings first
  eventEmitter.on(PRIVACY_SETTINGS_CONFIRMED, (preferences) => {
    // Load the script once to replace the placeholder
    if (isPlaceholder && preferences[KEY_GOOGLE_ANALYTICS]) {
      loadScript(`${analytics.gtag}?id=${gaPropertyID || gCrossMediaFloodlightID}`, 'gtag-tracking')
        .then(() => {
          isPlaceholder = false;
        })
        .catch(() => {
          // continue regardless of error
        });
    }

    const baseConfig = {
      send_page_view: false, // we send pageview ourself
      transport_type: 'beacon', // google will switch to default in the future,
      anonymizeIp: true, // CCPA/GDPR
    };

    // https://developers.google.com/analytics/devguides/collection/gtagjs/user-opt-out
    window[`ga-disable-${gaPropertyID}`] = !preferences[KEY_GOOGLE_ANALYTICS];

    gtag('js', new Date());

    if (gaPropertyID) {
      gtag('config', gaPropertyID, baseConfig);
    }

    if (gCrossMediaFloodlightID && preferences[KEY_GOOGLE_FLOODLIGHT]) {
      gtag('config', gCrossMediaFloodlightID, baseConfig);
    }

    // Google Ads Remarketing Tag for conversion tracking in Brazil
    if (googleAdsRemarketingID) {
      gtag('config', googleAdsRemarketingID, baseConfig);
    }
  });
};

export default init;
